import {toast} from "react-hot-toast";

export default function ResponseErrorHandel(error) {

    const status = error?.response?.data?.data?.status || error?.response?.data?.status;
    const message = error?.response?.data?.data?.message || error?.response?.data?.message;


    if (!error?.response) {
        toast.error("Check Your Internet and Try Again Later");
    } else {


        switch (status) {
            case 400:
            case 402:
            case 403:
            case 404:
            case 409:
                toast.error(message);
                break;
            case 401:
                localStorage.clear();
                break;
            default:
                if (status >= 500) {
                    toast.error("Internal Server Error");
                }
                break;
        }

    }


}

